export const ChipDesign = Object.freeze({
	Filled: 'filled',
	FilledSuccess: 'filled-success',
	FilledAlert: 'filled-alert',
	FilledWarning: 'filled-warning',
	FilledNoAccent: 'filled-no-accent',
	FilledInverted: 'filled-inverted',
	FilledSuccessInverted: 'filled-success-inverted',
	FilledAlertInverted: 'filled-alert-inverted',
	FilledWarningInverted: 'filled-warning-inverted',
	FilledNoAccentInverted: 'filled-no-accent-inverted',
	FilledBitrixGpt: 'filled-bitrix-gpt',
	Tinted: 'tinted',
	TintedSuccess: 'tinted-success',
	TintedAlert: 'tinted-alert',
	TintedWarning: 'tinted-warning',
	TintedNoAccent: 'tinted-no-accent',
	OutlineAccent: 'outline-accent',
	OutlineAccent2: 'outline-accent-2',
	OutlineSuccess: 'outline-success',
	OutlineAlert: 'outline-alert',
	OutlineWarning: 'outline-warning',
	Outline: 'outline',
	OutlineNoAccent: 'outline-no-accent',
	OutlineCopilot: 'outline-copilot',
	OutlineBitrixGpt: 'outline-bitrix-gpt',
	ShadowNoAccent: 'shadow-no-accent',
	Shadow: 'shadow',
	ShadowAccent: 'shadow-accent',
	ShadowDisabled: 'shadow-disabled',
	ShadowOutlineAccent2: 'shadow-outline-accent-2',
	ShadowOutline: 'shadow-outline',
	Disabled: 'disabled',
});

export const ChipSize = Object.freeze({
	Lg: 'l',
	Md: 'm',
	Sm: 's',
	Xs: 'xs',
});
